//@ts-nocheck
import { getConfig } from "../config/config";
import { decryptEnv } from "../helpers";
const { APP_BASE_APIHUB_API_URL } = getConfig();
export const getIsinNumberEquity = async (symbolInfo, startDate, endDate) => {
    let fullString = symbolInfo.ticker;
    let parts = fullString.split(":");
    let exchParam = parts[0];
    let symbolDesc = parts[1].split("/")[0];
    let scripCodePart = parts[1].split("/")[1].split("-")[0];
    const papiToken = "U2FsdGVkX19LOFCnmRagdbTL1qY6xSvIJsdMhM9F5ZYqng73l8lZ4ck6tAUpQaHw3A904Mzc10K9J1Yba84OAg";
    let url;
    if (exchParam.toLowerCase() === "nse") {
        url = `${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Equity/Market.svc/MultiIndexGetCodes/nse/?symbol=${symbolDesc}&responsetype=json`;
    }
    else {
        url = `${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Equity/Market.svc/MultiIndexGetCodes/bse/?bsecode=${scripCodePart}&responsetype=json`;
    }
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: "Basic " + decryptEnv(papiToken),
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const api_response = await response.json();
        let isinNumber = api_response.response.data.multiindexlist.multiindex.isin;
        return isinNumber;
    }
    catch (err) {
        console.error('Fetch error:', err);
        return null;
    }
};
